import { useTranslation } from 'react-i18next';
import { AgeValue, OptionKeyValue } from '@myriadgenetics/mgh-types';
import get from 'lodash.get';
import { Text3 } from '../../../elements/typography';
import './index.scss';

const SEPARATOR = ':';

type DetailProps = {
  testId?: string;
  displayKey: string | number | OptionKeyValue[];
  labelKey: string;
};

function MelanomaCancerDetail({ testId, displayKey, labelKey }: DetailProps) {
  const { t } = useTranslation();
  return (
    <p data-testid={testId} className={`melanoma-cancer-details__detail`}>
      <Text3 className="melanoma-cancer-details__detail-label text-medium--regular" tag="span">
        {`${t(labelKey)}${SEPARATOR}`}
      </Text3>
      <Text3 tag="span" className="text-medium--semi-bold">
        {typeof displayKey === 'string' || typeof displayKey === 'number' ? t(String(displayKey)) : t(displayKey[0].optionValue)}
      </Text3>
    </p>
  );
}

interface Props {
  pathology: {
    age?: AgeValue | string;
    melanomas?: string | number | OptionKeyValue[];
  };
}

function MelanomaCancerDetails({ pathology }: Props) {
  const hasMelanomas = pathology.melanomas !== undefined;

  return (
    <div data-testid="melanoma-cancer-details" className="melanoma-cancer-details">
      <MelanomaCancerDetail testId="melanoma-cancer-details-age" labelKey="review.ageOfDiagnosis" displayKey={get(pathology, 'age', 'pathology.dontKnow')} />
      {hasMelanomas && (
        <MelanomaCancerDetail
          testId="melanoma-cancer-details-melanomas"
          labelKey="review.melanomas"
          displayKey={get(pathology, 'melanomas', 'pathology.dontKnow')}
        />
      )}
    </div>
  );
}

export default MelanomaCancerDetails;
